export const adjustedServicePointProblemDescription =
  'Shipment was diverted to service-point, but we could not collect service-point data yet.'
